@use "@fukuri-admins/ui/layout" as *;

.screen {
  @include screen;
}

.content {
  @include content;
}

.body {
  @include body;
}
